import { render, staticRenderFns } from "./DialogAlvs.vue?vue&type=template&id=856ddc98&"
import script from "./DialogAlvs.vue?vue&type=script&lang=js&"
export * from "./DialogAlvs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports